const SET = 'set';
const SET_SEARCH_PARAM = 'setSearchParam';
const SET_WIDGET_ITEMS = 'setWidgetItems';
export default {
	SET,
	SET_SEARCH_PARAM,
	SET_WIDGET_ITEMS
};
